import { render } from "./OrgUsers.vue?vue&type=template&id=ec6f99be&scoped=true"
import script from "./OrgUsers.vue?vue&type=script&lang=js"
export * from "./OrgUsers.vue?vue&type=script&lang=js"

import "./OrgUsers.vue?vue&type=style&index=0&id=ec6f99be&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec6f99be"]])

export default __exports__